import { render, staticRenderFns } from "./keyvalue.vue?vue&type=template&id=15bdcf72&scoped=true"
import script from "./keyvalue.vue?vue&type=script&lang=js"
export * from "./keyvalue.vue?vue&type=script&lang=js"
import style0 from "./keyvalue.vue?vue&type=style&index=0&id=15bdcf72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bdcf72",
  null
  
)

export default component.exports